import React from 'react'
import {
  IMG_ERROR,
  VERIFYING_TEXT,
  IMG_SUCCESS,
  PASSED_TEXT,
  COLOR_SUCCESS,
  COLOR_ERROR,
  IMG_WARNING,
  COLOR_WARNING
} from '@constant'

const types = {
  success: {
    color: COLOR_SUCCESS,
    text: PASSED_TEXT,
    img: IMG_SUCCESS
  },
  warning: {
    color: COLOR_WARNING,
    text: reason => `${reason || VERIFYING_TEXT}`,
    img: IMG_WARNING
  },
  error: {
    color: COLOR_ERROR,
    text: reason => `审核不通过，原因：${reason}，请修改后重新提交`,
    img: IMG_ERROR
  }
}

export default ({ type, reason }) => {
  const { color, text, img } = types[type]

  return (
    <p style={{ color, margin: '14px 0' }}>
      <img src={img} style={{ verticalAlign: 'middle', marginRight: 3 }} />
      <span style={{ verticalAlign: 'middle' }}>
        {typeof text === 'function' ? text(reason) : text}
      </span>
    </p>
  )
}
